module.exports = __webpack_public_path__ + "img/law2.0ec85ce4.jpg";